import React from 'react'
import { setSourceId } from '../globals/load-analytics'
import { identify } from '../globals/tracking/tracking'
import { generateSessionId } from '../helper/session-id'
import { getGlobals, setGlobals } from '../globals/globals'
import SEO from './seo'
import ProgressBar from './progress-bar'
import { trackVisit } from '../globals/tracking/track'
import queryString from 'querystring'

function getCurrentProgress(props, progressTotal) {
  const { pageContext } = props

  const pos = pageContext.sortedPages.indexOf(pageContext.pageId)
  if (pos === -1) {
    return progressTotal
  }

  return pos + 1
}

export default class PageWrapper extends React.Component {
  constructor(props) {
    super(props)

    setSourceId(props.pageContext.trackingKey)

    if (typeof window !== `undefined`) {
      window.Rollbar.configure({ hostWhiteList: [props.pageContext.url] })
    }

    const sessionId = generateSessionId()
    setGlobals({
      perspectiveSessionId: sessionId,
    })
  }

  componentDidMount() {
    const initialTraits = this.getInitialTraits()
    identify(initialTraits)
    const {perspectiveSessionId} = getGlobals()
    window.Rollbar.configure({ payload: { sessionId: perspectiveSessionId } })
    this.trackVisit()

  }

  // Global Error Catcher
  componentDidCatch(error, errorInfo) {
    window.Rollbar.error(error) // eslint-disable-line no-undef
  }

  getInitialTraits() {
    const query = queryString.parse(this.props.location.search.substr(1))
    const traits = {}
    Object.keys(query)
      .filter((key) => {
        return key.indexOf('ps_trait_') > -1
      })
      .forEach((key) => {
        traits[key.replace('ps_trait_', '')] = query[key]
      })

    return traits
  }

  trackVisit() {
    trackVisit()
  }

  render() {
    const { element, pageContext, data } = this.props
    let progressTotal = pageContext.sortedPages.length

    const hasResultPages = data.campaignData.pages
      .filter(({ isResult }) => !!isResult)
      .length

    if (!!hasResultPages) {
      progressTotal += 1
    }

    return (
      <React.Fragment>
        <SEO url={pageContext.url}/>

        {element}

        <ProgressBar
          key="progress-bar"
          total={progressTotal}
          current={getCurrentProgress(this.props, progressTotal)}
        />
      </React.Fragment>
    )

  }
}
